import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export const FieldLabel: React.FC<{
  label?: string | JSX.Element;
  children: React.ReactNode;
  labelId?: string;
  color?: string;
  required?: boolean;
  toolTipTitle?: string;
  totalHeightForLabelAndField?: number;
}> = ({
  children,
  label,
  labelId,
  color,
  required,
  toolTipTitle,
  totalHeightForLabelAndField,
}) => {
  return (
    <Box sx={{ mb: 2, height: totalHeightForLabelAndField }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          id={labelId}
          component="label"
          variant="subtitle2"
          color={color ? color : undefined}
        >
          {label}
          {required && (
            <Typography component={"span"} color={"error"}>
              *
            </Typography>
          )}
        </Typography>
        {toolTipTitle && (
          <Tooltip
            title={toolTipTitle}
            placement="right-start"
            aria-label="tooltip information"
          >
            <InfoOutlined sx={{ ml: 1, fontSize: 16 }} />
          </Tooltip>
        )}
      </Box>
      <Box sx={{ mt: 0.5 }}>{children}</Box>
    </Box>
  );
};
